import loadComponentByIntersectionObserver from '../common/utils/loadComponentByIntersectionObserver';
import getFrontConfig from '../common/getFrontConfig';

const {
  urls: { staticJs },
} = getFrontConfig();

// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = staticJs;

function init() {
  loadComponentByIntersectionObserver('footer.footer', () => import(
    // eslint-disable-next-line comma-dangle
    /* webpackChunkName: "footer.js" */ './footer'
  ), {
    rootMargin: '100% 0px',
  });
}

export {
  init,
};
